<template lang="html">
  <div class="info-modal" :class="style.infoModal">
    <div class="modal-container">
      <slot name="title"></slot>
      <slot name="content"></slot>
      <div class="modal-actions">
        <slot name="actions"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.component('info-modal', {
    
    props: {
      title: {
        type: String,
        default: null
      }
    },
    computed: {
      style () {
        return {
          infoModal: this.$css(`
            &.info-modal {
              font-weight: ${this.theme.boldFontWeight} !important;

              .modal-container {

                .modal-title {
                  font-family: ${this.theme.mainFontFamily} !important;
                  color: ${this.theme.blackTextColor} !important;
                }

                .modal-value {
                  font-family: ${this.theme.mainFontFamily} !important;
                  & a {
                    color: ${this.theme.GDPRLinkColor} !important;
                    font-weight: ${this.theme.GDPRTextWeight} !important;
                  }
                }

                .modal-actions {
                  font-family: ${this.theme.headerFontFamily} !important;

                  span {
                    border-radius: ${this.theme.actionBarButtonRadius} !important;
                    font-family: ${this.theme.actionBarButtonFontFamily} !important ;
                    background-color: ${this.theme.actionNormalColor} !important;
                  }
                }
              }
            }
          `)
        }
      },
    },
    data () {
      const GDPRLevel = this.$store.state.GDPR.selected
      const copyNamespace = `${GDPRLevel}GDPR`
      return {
        showModal: false,
        copyNamespace: copyNamespace
      }
    }
  })
</script>

<style lang="scss">
  @import '../assets/mixins';

  .info-modal {
    font-weight: $boldFontWeight;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-color: #00000050;
    z-index: 50;
    position: absolute;
    margin-top: -30px;
    padding: 0 30px;
    height: 100vh;

    @include desktop {
      margin-top: -30px;
      height: 500px;
      width: 100%;
    }

    @include desktop-big {
      margin-top: -20px;
      width: 610px;
      height: 600px;
    }

    .modal-container {
      background-color: white;
      color: black;
      padding: 30px 29px 22px;
      border-radius: 0;
      width: 90%;
      text-align: center;
      border-radius: 5px;
      max-width: 335px;


      .modal-title {
        font-family: $mainFontFamily;
        color: $blackTextColor;
        font-size: 19px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 25px;
        text-align: center;
      }

      .modal-content {
        margin-top: 20px;
        list-style: inside;
        list-style-position: outside;
        padding-left: 20px;
      }

      .modal-value {
        font-family: $mainFontFamily;
        color: #19191A;
        line-height: 26px;
        text-align: center;
        white-space: pre-wrap;
        word-wrap: break-word;
        white-space: normal;
        box-shadow: none;
        font-size: 16px;
        letter-spacing: 0;
        line-height: 28px;
        text-align: left;
        margin: 0;
        &:last-of-type {
            margin-bottom: 15px;
        }
        & a {
          color: $GDPRLinkColor;
          font-size: 16px;
          font-weight: $GDPRTextWeight;
          text-decoration: none;
        }
      }

      .modal-actions {
        font-size: 18px;
        font-family: $headerFontFamily;
        color: #71CB6D;
        text-transform: uppercase;
        margin-top: 20px;
        text-align: center;

        span {
          box-sizing: border-box;
          border-radius: $actionBarButtonRadius;
          font-family: $actionBarButtonFontFamily ;
          text-transform: uppercase;
          flex-shrink: 0;
          line-height: 25px;
          padding: 17px 5px;
          margin: 5px auto;
          font-size: 18px;
          width: 100%;
          max-width: 200px;
          display: block;
          color: white !important;
          background-color: $actionNormalColor;
          cursor: pointer;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/InfoModal.vue